export const HEADER_V1 = 'v1';
export const HEADER_V2 = 'v2';

export const DESKTOP_FAT_GUTTER = '60';
export const DESKTOP_THIN_GUTTER = '32';
export const MOBILE_GUTTER = '16';

export const APP_BAR_Z_INDEX = 1100; // Matches the Material UI AppBar z-index

export const SINGLE_COLUMN_FORM_WIDTH = 512;
